export const buyerPersonaFieldHelp = {
  name: {
    description: 'Nome da persona compradora, como o time comercial e de produto a identificam.',
    example: 'Ana, Head de Operações',
  },
  code: {
    description:
      'Identificador interno opcional. Se vazio, o sistema gera a partir do nome. Use só letras minúsculas, números e hífen.',
    example: 'ana-head-operacoes',
  },
  jobTitle: {
    description: 'Cargo típico desta persona na empresa cliente.',
    example: 'Head de Operações',
  },
  seniority: {
    description: 'Nível hierárquico usual, para ajustar a abordagem comercial e o discurso.',
    example: 'Diretor',
  },
  description: {
    description: 'Quem é essa pessoa, o contexto do trabalho e o papel na decisão de compra.',
    example: 'Lidera operação e busca reduzir tempo de atendimento sem aumentar headcount',
  },
  painPoints: {
    description: 'Dores e frustrações que esta persona enfrenta no dia a dia.',
    example: 'Fila de tickets sem priorização e relatórios manuais no fim do mês',
  },
  goals: {
    description: 'O que esta persona quer alcançar e como o produto ajuda nesse resultado.',
    example: 'Padronizar o atendimento e medir SLA em tempo real',
  },
} as const;
